<template>
    <rkm-modal
        persistent
        ref="RkmModal"
        :title="sign ? 'Documentos' : 'Opções de impressão'"
    >
        <rkm-form
            v-if="model"
            ref="RkmForm"
        >
            <rkm-row>
                <rkm-col>
                    <rkm-form-checkbox
                        v-if="form.impressoes.length > 1"
                        :indeterminate="indeterminate"
                        :value="true"
                        @change="checkUncheckAll"
                        v-model="checkedAll"
                    >
                        Todos
                    </rkm-form-checkbox>

                    <rkm-form-checkbox-group
                        class="mb-0"
                        stacked
                        v-model="model.impressoes"
                    >
                        <rkm-form-checkbox
                            v-for="(impressao, i) in form.impressoes"
                            @click.native="handleImpressaoClick($event, impressao)"
                            :key="i"
                            :value="impressao.value"
                        >
                            {{ impressao.text }}
                        </rkm-form-checkbox>
                    </rkm-form-checkbox-group>
                </rkm-col>
            </rkm-row>

            <rkm-row v-if="assinaturaEletronica && form.impressoes.length === 0
                && form.impressoesAssinadas.length > 0"
            >
                <rkm-col>
                    Não há documentos pendentes de assinatura.
                </rkm-col>
            </rkm-row>

            <rkm-row v-else-if="printSigned && form.impressoes.length === 0 && form.impressoesAssinadas.length === 0">
                <rkm-col>
                    Não há documentos assinados.
                </rkm-col>
            </rkm-row>

            <rkm-row v-else-if="sign && form.impressoes.length === 0">
                <rkm-col>
                    Não existem documentos configurados para serem assinados.
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <template v-slot:footer>
            <rkm-button @click="close">
                Fechar
            </rkm-button>

            <rkm-button
                v-if="!sign"
                :disabled="model && model.impressoes && model.impressoes.length === 0 || !!loading"
                @click="print"
                color="primary"
            >
                Imprimir {{printSigned ? 'assinados' : '' }}
            </rkm-button>

            <rkm-button
                v-else
                :disabled="model && model.impressoes && model.impressoes.length === 0 || !!loading"
                @click="handleSign"
                color="primary"
            >
                Continuar
            </rkm-button>
        </template>

        <ModalExameApac
            @cancel="uncheck('laudoSolicitacaoAutorizacaoProcedimentoAmbulatorial')"
            ref="ModalExameApac"
        />

        <ModalExameSadt
            @cancel="uncheck('fichaRequisicaoServicoAuxiliarDiagnoseTerapia')"
            ref="ModalExameSadt"
        />

        <ModalExameSadat
            @cancel="uncheck('servicoAnaliseDiagnosticoTerapiaSolicitacaoExame')"
            ref="ModalExameSadat"
        />

        <ModalPrescricaoMedicamentoNaoPadronizadoComum
            @cancel="uncheck('receitaMedicaNaoPadronizadaComum')"
            ref="ModalPrescricaoMedicamentoNaoPadronizadoComum"
        />

        <ModalPrescricaoMedicamentoNaoPadronizadoEspecial
            @cancel="uncheck('receitaMedicaNaoPadronizadaEspecial')"
            ref="ModalPrescricaoMedicamentoNaoPadronizadoEspecial"
        />

        <ModalPrescricaoMedicamentoComum
            @cancel="uncheck('receitaMedicaComum')"
            ref="ModalPrescricaoMedicamentoComum"
        />

        <ModalPrescricaoMedicamentoEspecial
            @cancel="uncheck('receitaMedicaEspecial')"
            ref="ModalPrescricaoMedicamentoEspecial"
        />

        <ModalPrescricaoMedicamentoEspecialAzul
            @cancel="uncheck('receitaMedicaEspecialAzul')"
            ref="ModalPrescricaoMedicamentoEspecialAzul"
        />

        <ModalPrescricaoMedicamentoEspecialAmarela
            @cancel="uncheck('receitaMedicaEspecialAmarela')"
            ref="ModalPrescricaoMedicamentoEspecialAmarela"
        />
    </rkm-modal>
</template>

<script>
// Components.
import ModalExameApac from './components/exame-apac/Modal'
import ModalExameSadt from './components/exame-sadt/Modal'
import ModalExameSadat from './components/exame-sadat/Modal'
import ModalPrescricaoMedicamentoNaoPadronizadoComum from './components/prescricao-medicamento/Modal'
import ModalPrescricaoMedicamentoNaoPadronizadoEspecial from './components/prescricao-medicamento/Modal'
import ModalPrescricaoMedicamentoComum from './components/prescricao-medicamento/Modal'
import ModalPrescricaoMedicamentoEspecial from './components/prescricao-medicamento/Modal'
import ModalPrescricaoMedicamentoEspecialAzul from './components/prescricao-medicamento/Modal'
import ModalPrescricaoMedicamentoEspecialAmarela from './components/prescricao-medicamento/Modal'

// Mixins.
import {error, file, repository, stringCase} from '@/mixins'

// Vuex.
import {mapActions, mapGetters} from 'vuex'

// Utils.
import senha from '@/utils/painel-senha/impressao/senha'

export default {
    components: {
        ModalExameApac,
        ModalExameSadt,
        ModalExameSadat,
        ModalPrescricaoMedicamentoNaoPadronizadoComum,
        ModalPrescricaoMedicamentoNaoPadronizadoEspecial,
        ModalPrescricaoMedicamentoComum,
        ModalPrescricaoMedicamentoEspecial,
        ModalPrescricaoMedicamentoEspecialAzul,
        ModalPrescricaoMedicamentoEspecialAmarela,
    },
    computed: {
        ...mapGetters({
            centroCusto: 'getCentroCusto',
            cliente: 'getCliente',
            loading: 'getLoading',
            lotacao: 'getLotacao',
        }),
    },
    created() {
        this.repositories = {
            impressao: this.getConectaSusRepository('ambulatorio.impressao'),
            pdf: this.getConectaSusRepository('impressao.ambulatorio'),
        }
    },
    data: () => ({
        atendimentoId: null,
        id: null,
        checkedAll: false,
        form: null,
        indeterminate: false,
        model: null,
        origem: null,
        utils: {senha},
        tipo: null
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(origem, atendimentoId, id = null) {
            this.origem = origem
            this.atendimentoId = atendimentoId
            this.id = id

            this.list()

            this.$refs.RkmModal.show()
        },
        list() {
            this.setLoading()

            const request = {
                origem: this.origem,
                atendimentoId: this.atendimentoId,
                soapId: this.id,
                assinados: !!this.printSigned,
                tipo: this.tipo
            }

            this.repositories.impressao.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {

                    this.form = Object.assign(response.data.form)
                    this.model = Object.assign(response.data.model)

                    if (this.sign && this.additionals.permissaoAssinatura.length > 0) {

                        this.form.impressoes = this.form.impressoes.filter(imp => {

                            return this.additionals.permissaoAssinatura.some(permissao => {

                                return imp.assinatura === permissao.id;
                            });
                        });
                    }

                    if (this.assinaturaEletronica) {

                        this.form.impressoes = this.form.impressoes.filter(imp => {

                            return !this.form.impressoesAssinadas.some(assinada => {

                                return imp.value === assinada.value;
                            });
                        });
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        checkUncheckAll(value) {

            if (this.assinaturaEletronica) {
                this.model.impressoes = value ? this.form.impressoes.map(impressao => impressao.value) : []

                return
            }

            this.form.impressoes.forEach(impressao => {
                if (['fichaRequisicaoServicoAuxiliarDiagnoseTerapia',
                    'laudoSolicitacaoAutorizacaoProcedimentoAmbulatorial',
                    'servicoAnaliseDiagnosticoTerapiaSolicitacaoExame',
                ].includes(impressao.value)) {
                    impressao.data.forEach(s => s.itens.forEach(i => i.checked = value))
                }
                else if (['receitaMedicaNaoPadronizadaComum',
                    'receitaMedicaNaoPadronizadaEspecial',
                    'receitaMedicaComum',
                    'receitaMedicaEspecial',
                    'receitaMedicaEspecialAzul',
                    'receitaMedicaEspecialAmarela',
                ].includes(impressao.value)) {
                    impressao.data.forEach(p => p.medicamentos.forEach(m => m.checked = value))
                }
            })

            this.model.impressoes = value ? this.form.impressoes.map(impressao => impressao.value) : []
        },
        handleImpressaoClick(event, impressao) {

            if (this.printSigned) return;

            if (impressao.value === 'fichaRequisicaoServicoAuxiliarDiagnoseTerapia') {
                if (event.target.checked) {
                    this.$refs.ModalExameSadt.open(impressao)
                }
                else {
                    impressao.data.forEach(s => s.itens.forEach(i => i.checked = false))
                }
            }
            else if (impressao.value === 'servicoAnaliseDiagnosticoTerapiaSolicitacaoExame') {
                if (event.target.checked) {
                    this.$refs.ModalExameSadat.open(impressao)
                }
                else {
                    impressao.data.forEach(s => s.itens.forEach(i => i.checked = false))
                }
            }
            else if (impressao.value === 'laudoSolicitacaoAutorizacaoProcedimentoAmbulatorial') {
                if (event.target.checked) {
                    this.$refs.ModalExameApac.open(impressao)
                }
                else {
                    impressao.data.forEach(s => s.itens.forEach(i => i.checked = false))
                }
            }
            else if (impressao.value === 'receitaMedicaNaoPadronizadaComum') {
                if (event.target.checked) {
                    this.$refs.ModalPrescricaoMedicamentoNaoPadronizadoComum.open(impressao)
                }
                else {
                    impressao.data.forEach(p => p.medicamentos.forEach(m => m.checked = false))
                }
            }
            else if (impressao.value === 'receitaMedicaNaoPadronizadaEspecial') {
                if (event.target.checked) {
                    this.$refs.ModalPrescricaoMedicamentoNaoPadronizadoEspecial.open(impressao)
                }
                else {
                    impressao.data.forEach(p => p.medicamentos.forEach(m => m.checked = false))
                }
            }
            else if (impressao.value === 'receitaMedicaComum') {
                if (event.target.checked) {
                    this.$refs.ModalPrescricaoMedicamentoComum.open(impressao)
                }
                else {
                    impressao.data.forEach(p => p.medicamentos.forEach(m => m.checked = false))
                }
            }
            else if (impressao.value === 'receitaMedicaEspecial') {
                if (event.target.checked) {
                    this.$refs.ModalPrescricaoMedicamentoEspecial.open(impressao)
                }
                else {
                    impressao.data.forEach(p => p.medicamentos.forEach(m => m.checked = false))
                }
            }
            else if (impressao.value === 'receitaMedicaEspecialAzul') {
                if (event.target.checked) {
                    this.$refs.ModalPrescricaoMedicamentoEspecialAzul.open(impressao)
                }
                else {
                    impressao.data.forEach(p => p.medicamentos.forEach(m => m.checked = false))
                }
            }
            else if (impressao.value === 'receitaMedicaEspecialAmarela') {
                if (event.target.checked) {
                    this.$refs.ModalPrescricaoMedicamentoEspecialAmarela.open(impressao)
                }
                else {
                    impressao.data.forEach(p => p.medicamentos.forEach(m => m.checked = false))
                }
            }
        },
        uncheck(impressao) {
            this.model.impressoes.splice(this.model.impressoes.findIndex(i => i === impressao), 1)
        },
        print() {
            this.$emit('print')

            const items = {
                senha: async () => {
                    await this.utils.senha.print({
                        ...this.form.impressoes.find(impressao => impressao.value === 'senha').data,
                        infraestrutura: this.lotacao.infraestrutura.nome,
                        setor: this.centroCusto.setor.nome,
                        cliente: this.cliente.nome,
                    });
                },
                fichaNotificacaoSinan: async () => {
                    this.setLoading();
                    try {
                        const { data } = await this.repositories.pdf.fichaNotificacao(this.atendimentoId, { atendimento_id: this.atendimentoId });
                        const blob = new Blob([data], { type: 'text/html' });
                        const url = URL.createObjectURL(blob);
                        window.open(url, '_blank');

                        setTimeout(() => URL.revokeObjectURL(url), 10000);
                    } catch (err) {
                        this.handleError(err);
                    } finally {
                        this.unsetLoading();
                    }
                }
            };

            this.model.impressoes.forEach(impressao => {
                if (impressao in items) {
                    items[impressao]().catch(this.handleError);
                }
            });

            const impressoesPDF = this.model.impressoes.filter(i => i !== 'fichaNotificacaoSinan');

            if (impressoesPDF.length === 0) {
                return;
            }

            const impressoes = impressoesPDF.map(impressao => {

                if (this.printSigned) return impressao;

                if (['fichaRequisicaoServicoAuxiliarDiagnoseTerapia', 'laudoSolicitacaoAutorizacaoProcedimentoAmbulatorial'].includes(impressao)) {
                    const itens = [];
                    this.form.impressoes.find(i => i.value === impressao).data
                        .forEach(s => s.itens.filter(i => i.checked).forEach(i => itens.push({origem: s.origem, id: i.id})));
                    return [impressao, {itens}];
                }
                else if (impressao === 'servicoAnaliseDiagnosticoTerapiaSolicitacaoExame') {
                    const itens = [];
                    this.form.impressoes.find(i => i.value === impressao).data
                        .forEach(s => s.itens.filter(i => i.checked).forEach(item => itens.push({
                            tipo_solicitacao: item.tipoSolicitacao,
                            id: item.id,
                            solicitacao_id: item.solicitacaoId,
                            exame_id: item.exameId,
                        })));
                    return [impressao, {itens}]
                }
                else if (['receitaMedicaNaoPadronizadaComum',
                    'receitaMedicaNaoPadronizadaEspecial',
                    'receitaMedicaComum',
                    'receitaMedicaEspecial',
                    'receitaMedicaEspecialAzul',
                    'receitaMedicaEspecialAmarela',
                ].includes(impressao)) {
                    const medicamentos = []

                    this.form.impressoes.find(i => i.value === impressao).data
                        .forEach(p => p.medicamentos.filter(m => m.checked).forEach(m => medicamentos.push(m.id)))

                    return [impressao, {medicamentos}]
                }
                return impressao;
            });

            if (this.printSigned) {

                impressoes.forEach(impressao => {

                    this.setLoading()

                    this.repositories.pdf.assinados(this.atendimentoId, { tipo: impressao })
                        .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading());
                });
            } else {

                this.setLoading()

                this.repositories.pdf.geral(this.atendimentoId, impressoes)
                    .then(({data, headers}) => this.openFile(data, headers['content-type']))
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        close() {
            this.$refs.RkmModal.hide()
            this.$emit('closed', this.atendimentoId)
        },
        handleSign() {

            const impressoes = this.model.impressoes.map(impressao => {

                if (['fichaRequisicaoServicoAuxiliarDiagnoseTerapia',
                    'laudoSolicitacaoAutorizacaoProcedimentoAmbulatorial',
                ].includes(impressao)) {
                    const itens = []

                    this.form.impressoes.find(i => i.value === impressao).data
                        .forEach(s => s.itens.filter(i => i.checked).forEach(i => itens.push({origem: s.origem, id: i.id})))

                    return [impressao, {itens}]
                }
                else if (['receitaMedicaNaoPadronizadaComum',
                    'receitaMedicaNaoPadronizadaEspecial',
                    'receitaMedicaComum',
                    'receitaMedicaEspecial',
                    'receitaMedicaEspecialAzul',
                    'receitaMedicaEspecialAmarela',
                ].includes(impressao)) {
                    const medicamentos = []

                    this.form.impressoes.find(i => i.value === impressao).data
                        .forEach(p => p.medicamentos.filter(m => m.checked).forEach(m => medicamentos.push(m.id)))

                    return [impressao, {medicamentos}]
                }
                else if (impressao === 'servicoAnaliseDiagnosticoTerapiaSolicitacaoExame') {
                    const itens = []

                    this.form.impressoes.find(i => i.value === impressao).data
                        .forEach(s => s.itens.filter(i => i.checked).forEach(item => itens.push({
                            tipo_solicitacao: item.tipoSolicitacao,
                            id: item.id,
                            solicitacao_id: item.solicitacaoId,
                            exame_id: item.exameId,
                        })))

                    return [impressao, {itens}]
                }

                return impressao
            })

            this.$refs.RkmModal.hide()
            this.$emit('continue', impressoes, this.atendimentoId, this.id)
        }
    },
    mixins: [error, file, repository, stringCase],
    props: {
        sign: {type: Boolean, default: false},
        printSigned: {type: Boolean, default: false},
        assinaturaEletronica: {type: Boolean, default: false},
        additionals: {type: Object},
    },
    watch: {
        'model.impressoes'(value) {
            this.checkedAll = value.length > 0 && value.length == this.form.impressoes.length
            this.indeterminate = value.length > 0 && value.length != this.form.impressoes.length
        },
    },
}
</script>